if (!customElements.get('product-compatible-vehicles')) {
  customElements.define(
    'product-compatible-vehicles',
    class ProductCompatibleVehicles extends HTMLElement {
      constructor() {
        super();
        this.records = [];
        this.filtered = [];
        this.visibleCount = 30;
        this.fields = ['maker', 'model', 'vehicle_code', 'application_period'];
      }

      connectedCallback() {
        this.load();
      }

      async load() {
        try {
          const response = await fetch(this.dataset.source);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const payload = await response.json();
          const handle = this.dataset.productHandle.toLowerCase();
          const sku = this.dataset.productSku.toLowerCase();
          const seen = new Set();
          this.records = (payload.records || []).filter((record) => {
            const matches = record.product_handle?.toLowerCase() === handle || (sku && record.product_sku?.toLowerCase() === sku);
            const key = [record.maker, record.model, record.vehicle_code, record.application_period, record.engine_code].join('|');
            if (!matches || seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          this.bind();
          this.update();
        } catch (error) {
          this.querySelector('[data-fitment-count]').textContent = '適合データを読み込めませんでした';
        }
      }

      bind() {
        this.querySelector('[data-fitment-filters]').hidden = false;
        this.querySelector('[data-fitment-results]').hidden = false;
        this.fields.forEach((field) => this.querySelector(`[data-filter="${field}"]`).addEventListener('change', () => {
          this.visibleCount = 30;
          this.update(field);
        }));
        this.querySelector('[data-fitment-reset]').addEventListener('click', () => {
          this.fields.forEach((field) => { this.querySelector(`[data-filter="${field}"]`).value = ''; });
          this.visibleCount = 30;
          this.update();
        });
        this.querySelector('[data-fitment-more]').addEventListener('click', () => {
          this.visibleCount += 30;
          this.renderRows();
        });
      }

      selections(excludedField = '') {
        return Object.fromEntries(this.fields.filter((field) => field !== excludedField).map((field) => [field, this.querySelector(`[data-filter="${field}"]`).value]));
      }

      matching(selections) {
        return this.records.filter((record) => Object.entries(selections).every(([field, value]) => !value || record[field] === value));
      }

      update() {
        this.fields.forEach((field) => {
          const select = this.querySelector(`[data-filter="${field}"]`);
          const current = select.value;
          const values = [...new Set(this.matching(this.selections(field)).map((record) => record[field]).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ja'));
          const firstLabel = select.options[0].textContent;
          select.replaceChildren(new Option(firstLabel, ''), ...values.map((value) => new Option(value, value)));
          select.value = values.includes(current) ? current : '';
        });
        this.filtered = this.matching(this.selections());
        this.renderRows();
      }

      renderRows() {
        const body = this.querySelector('[data-fitment-body]');
        body.replaceChildren(...this.filtered.slice(0, this.visibleCount).map((record) => {
          const row = document.createElement('tr');
          ['maker', 'model', 'vehicle_code', 'application_period', 'engine_code'].forEach((field) => {
            const cell = document.createElement('td');
            cell.textContent = record[field] || '—';
            row.appendChild(cell);
          });
          return row;
        }));
        const makers = new Set(this.filtered.map((record) => record.maker)).size;
        this.querySelector('[data-fitment-count]').textContent = `${this.filtered.length.toLocaleString('ja-JP')}件・${makers}メーカー`;
        this.querySelector('[data-fitment-empty]').hidden = this.filtered.length !== 0;
        this.querySelector('[data-fitment-results]').hidden = this.filtered.length === 0;
        this.querySelector('[data-fitment-more]').hidden = this.visibleCount >= this.filtered.length;
      }
    }
  );
}
